import { runInAction } from 'mobx';
import { updateObject } from '../../../utils/object-utils';
import { getNotifications } from '../selectors/get-notifications';
import { hasNotification } from '../selectors/has-notification';
import { sortNotifications } from '../utils/notification-sort-utils';
export const addNotification = (notification) => {
    // Do not add if already added.
    if (hasNotification(notification.id))
        return;
    notification.displayPriority = notification.displayPriority || 0;
    runInAction(() => {
        const notifications = getNotifications();
        notifications.push(notification);
        const sortedNotifications = sortNotifications(notifications);
        updateObject(notifications, sortedNotifications);
    });
};
